import jwt_decode from 'jwt-decode';

export default {

  checkAccessLevel(context, redirectTo, requiredAccessLevel) {
    let isAllowedAccess = false;
    let jwt = localStorage.getItem('id_token');
    if(jwt){
      let decoded = jwt_decode(jwt);
      if(decoded.access_level && decoded.access_level === requiredAccessLevel){
        isAllowedAccess = true;
      }
    }

    if(!isAllowedAccess && redirectTo) {
      context.$router.push(redirectTo);
    }
    return isAllowedAccess;
  },

  checkUserRole(context, redirectTo, requiredUserRole) {
    let isAllowedRole = false;
    let jwt = localStorage.getItem('id_token');
    if(jwt){
      let decoded = jwt_decode(jwt);
      if(decoded.user_role && decoded.user_role === requiredUserRole){
        isAllowedRole = true;
      }
    }

    if(!isAllowedRole && redirectTo) {
      context.$router.push(redirectTo);
    }
    return isAllowedRole;
  },

  decodejwt(context, redirectTo){
    try{
        let jwt = localStorage.getItem('id_token');
        var decoded = jwt_decode(jwt);
      }catch(err){
        console.log(err);
        context.$router.push({ name: 'Login' });
      }
    return decoded;
  },
  // checkExp(context, redirectTo){
  //    let jwt = localStorage.getItem('id_token');
  //    let isValid = false;
  //    if(jwt){
  //     let decoded = jwt_decode(jwt);
  //     if (decoded.exp > Date.now() / 1000) {
  //       isValid = false;
  //     }else{
  //       isValid = true;
  //     }
  //   }
  //   return isValid;
  // },
}


// WEBPACK FOOTER //
// ./src/components/utils/Utils.js